module.exports = __webpack_public_path__ + "static/media/Memeing.d59d0bf8.png";